export const AzureBlobFiles = { 
    MetaImage: "https://warrantyblob.blob.core.windows.net/$web/Care+_WebsitePreview.png",
    SampleContract: "https://warrantyblob-secondary.z13.web.core.windows.net/M2MVSCXX - NRF - clean- NG 091824- MAPPED (SAMPLE).pdf",
    SampleRO: "https://warrantyblob.blob.core.windows.net/$web/RO189516.pdf",
};